// Module port of the helper globals from snippets/global-js-css.liquid. New code should prefer
// native DOM APIs or ./dom.js; these keep the older section scripts working unchanged.

export function ge(sel, all) {
    return all ? document.querySelectorAll(sel) : document.querySelector(sel);
}

export function classHelper(els, action, className) {
    if (!els) return;
    const map = {
        c: 'contains',
        a: 'add',
        r: 'remove',
    };
    const checkEl = function (el) {
        if (!el.classList) return;
        if (action === 'c') {
            return el.classList[map[action]](className);
        }
        if (action === 'r') {
            el.classList.remove(className);
            return;
        }
        el.classList[map[action]](className);
    };
    if (action === 'c') return checkEl(els);

    if (!(els instanceof NodeList) && !Array.isArray(els)) return checkEl(els);
    for (let i = 0; i < els.length; i++) checkEl(els[i]);
}

// GET PARENT
export function gp(el, name, isTagName, isId) {
    for (let i = 0; i < 15; i++) {
        el = !i ? el : el.parentNode;
        if (!el || (el.tagName && el.tagName === 'BODY')) return;
        if (isTagName || isId) {
            const matchVal = isTagName ? el.tagName : el.id;
            if (matchVal === name) return el;
        } else if (classHelper(el, 'c', name)) {
            return el;
        }
    }
}

// GET CHILD
export function gc(el, sel, all) {
    return all ? el.querySelectorAll(sel) : el.querySelector(sel);
}

// COOKIE
export function getSetCookie(k, v, days) {
    const myDate = function (days) {
        return new Date(Date.now() + (days ? days * 86400000 : 31556952000)).toUTCString();
    };
    const expStr = ';expires=';
    // SET COOKIE
    if (days || v || v === 0) {
        let value = k + '=' + encodeURIComponent(v) + expStr + myDate(days);
        if (v || v === 0) value += ';path=/';
        // Fix: "The operation is insecure." — document.cookie can throw in restricted contexts.
        try { document.cookie = value; } catch (e) {}
        return;
    }
    // PARSE AND RETURN COOKIE
    const cookies = document.cookie.split(/\s*;\s*/);
    for (let i = 0; i < cookies.length; i++) {
        const c = cookies[i];
        const arr = c.split('=');
        if (arr && arr.length && c.indexOf(k) > -1) {
            if (arr[0] !== k) continue;
            // Fix: "URI error" (URIError) — malformed cookie value crashes decodeURIComponent.
            try { return decodeURIComponent(arr[1]); } catch (e) { return arr[1]; }
        }
    }
    return false;
}

// CREATE ELEMENT
export function createEl(tagName, propName) {
    propName = propName || '';
    const el = document.createElement(tagName);
    if (propName) {
        const isId = propName.indexOf('#') > -1;
        propName = propName.replace('.', '').replace('#', '');
        isId ? el.id = propName : el.className = propName;
    }
    return el;
}

// APPEND CHILD
export function appendChild(parent, children) {
    if (!Array.isArray(children)) children = [children];
    for (let i = 0; i < children.length; i++) parent.appendChild(children[i]);
}

// GET ELEMENT
export function getEl(sel, all) {
    const els = all ? document.querySelectorAll(sel) : document.querySelector(sel);
    return all ? (els && els.length ? els : null) : els;
}

// GET PARENT
export function getParent(el, name, isTagName) {
    let isClass = true;
    let isId = name.indexOf('#') > -1;
    if (isId) isClass = false;
    if (isClass) name = name.replace('.', '');
    if (isTagName) {
        isClass = isId = false;
        name = name.toUpperCase();
    }
    for (let i = 0; i < 15; i++) {
        el = !i ? el : el.parentNode;
        if (!el || (el.tagName && el.tagName === 'BODY')) return;
        if (isTagName || isId) {
            const matchVal = isTagName ? el.tagName : el.id;
            if (matchVal === name) return el;
        } else if (classHelper(el, 'c', name)) {
            return el;
        }
    }
}

// GET CHILD
export function getChild(el, sel, all) {
    const childEls = all ? el.querySelectorAll(sel) : el.querySelector(sel);
    return all ? (childEls && childEls.length ? childEls : null) : childEls;
}

// INNER HTML
export function innerHtml(el, str) {
    if (!str && str !== '') return el.innerHTML;
    el.innerHTML = str;
}

// TEXT CONTENT
export function textContent(el, str) {
    if (!str && str !== 0) return el.textContent;
    el.textContent = str;
}

export function getAttribute(el, name, isDataAtrribute) {
    return el.getAttribute(isDataAtrribute ? 'data-' + name : name);
}

export function setAttribute(el, name, str) {
    return el.setAttribute(name, str);
}

export function getKV(k) {
    const o = Object.create(null);
    const params = location.search.split(/\?|&/g);
    for (let i = 0; i < params.length; i++) {
        const p = params[i];
        if (p !== '') {
            const thisKV = p.split('=');
            // Fix: "URI error" (URIError) — malformed % in query params crashes decodeURIComponent.
            try { o[thisKV[0]] = decodeURIComponent(thisKV[1]); } catch (e) { o[thisKV[0]] = thisKV[1]; }
        }
    }
    if (k) {
        if (o[k]) return o[k];
        return null;
    }
    return o;
}
